// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"b_wcMB"};